export default () => ({
  SET_ITEM: (state, item) => (state.item = { ...item, password: "", password_confirmation: "" }),

  SET_INVALID_FIELDS: (state, payload) => (state.invalidFields = payload)
})
